const WA_LINK = "https://wa.me/5554996914900?text=Ol%C3%A1%2C%20quero%20parar%20de%20pagar%20juros%20abusivos.%20Solicito%20minha%20avalia%C3%A7%C3%A3o.";
const ANALYSIS_LINK = "https://wa.me/5554996914900?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20minha%20avalia%C3%A7%C3%A3o%20gratuita.";

export default function CTAForte() {
  return (
    <section className="py-28 bg-[#1A1A1A] relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=close%20up%20abstract%20dark%20textured%20background%20subtle%20geometric%20pattern%20sophisticated%20legal%20professional%20dark%20charcoal%20black%20minimal%20texture%20elegant%20pattern%20no%20people&width=1920&height=800&seq=ctabg01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A1A] via-[#1A1A1A]/90 to-[#1A1A1A]" />
      </div>

      {/* Red line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-[#B32025]" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-2 bg-[#B32025]/15 border border-[#B32025]/30 px-4 py-2 rounded-full mb-8">
          <div className="w-2 h-2 rounded-full bg-[#B32025] animate-pulse" />
          <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest font-sans">
            Ação Imediata
          </span>
        </div>

        <h2 className="font-serif text-white text-4xl lg:text-5xl font-bold leading-tight mb-6">
          Pare de pagar{" "}
          <em className="text-[#B32025] not-italic">juros abusivos</em>
          <br />
          agora mesmo
        </h2>

        <p className="text-[#BFBFBF] text-lg leading-relaxed mb-12 font-sans max-w-2xl mx-auto">
          Cada mês que passa, você perde mais dinheiro. Solicite agora sua avaliação gratuita e descubra se você tem direito à <strong className="text-white">revisão de juros</strong> e redução da sua dívida bancária.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="group w-full sm:w-auto flex items-center justify-center gap-3 bg-[#B32025] hover:bg-[#8E1A1E] text-white font-bold px-10 py-5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg leading-none" />
            </div>
            Falar no WhatsApp agora
            <div className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
              <i className="ri-arrow-right-line text-sm leading-none" />
            </div>
          </a>
          <a
            href={ANALYSIS_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto flex items-center justify-center gap-2 border border-white/20 hover:border-white/50 text-white hover:bg-white/8 font-medium px-10 py-5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
          >
            Solicitar avaliação
          </a>
        </div>

        {/* Small trust line */}
        <p className="text-[#BFBFBF]/50 text-xs font-sans mt-8">
          Sem custo inicial · Atendimento sigiloso · Advogado inscrito na OAB
        </p>
      </div>
    </section>
  );
}
